import AdminCrudPage from "./AdminCrudPage";

export default function AdminEvents() {
  return (
    <AdminCrudPage
      title="Events"
      endpoint="events"
      initial={{ title: "", description: "", location: "", event_date: "", cover_image: "", published: true }}
      columns={[
        { key: "title", label: "Title" },
        { key: "event_date", label: "Date" },
        { key: "location", label: "Location" },
        { key: "published", label: "Published", render: (it) => it.published ? "Yes" : "Draft" },
      ]}
      fields={[
        { name: "title", label: "Title" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "location", label: "Location" },
        { name: "event_date", label: "Event Date (YYYY-MM-DD)" },
        { name: "cover_image", label: "Cover Image", type: "image" },
        { name: "published", label: "Published", type: "boolean" },
      ]}
    />
  );
}
